import { Actions } from './layer.actions'
import { fromJS } from 'immutable'
import * as LayerTypes from './layer.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 10,
    },
    total: 0,
    results: 0,
  },
  createLayer: {
    isLoading: false,
    validationErrors: {},
    data: {
      name: '',
      calculation: false,
      delivery: false,
      active: false,
      color: '#ffff00',
    },
  },
  updateLayer: {
    isLoading: false,
    isUploading: false,
    validationErrors: {},
    data: {
      color: '#ffff00',
    },
  },
})

export function layerReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case LayerTypes.UPDATE_LAYER_REQUEST: {
      return state
        .setIn(['updateLayer', 'isLoading'], true)
        .setIn(['updateLayer', 'validationErrors'], fromJS({}))
    }

    case LayerTypes.UPDATE_LAYER_SUCCESS: {
      return state.setIn(['updateLayer', 'isLoading'], false)
    }

    case LayerTypes.UPDATE_LAYER_FAILURE: {
      return state.setIn(['updateLayer', 'isLoading'], false)
    }

    case LayerTypes.UPLOAD_LAYER_FILE_REQUEST: {
      return state.setIn(['updateLayer', 'isUploading'], true)
    }

    case LayerTypes.UPLOAD_LAYER_FILE_SUCCESS: {
      return state
        .setIn(['updateLayer', 'isUploading'], false)
        .setIn(['updateLayer', 'data'], fromJS(action.payload))
    }

    case LayerTypes.UPLOAD_LAYER_FILE_FAILURE: {
      return state.setIn(['updateLayer', 'isUploading'], false)
    }

    case LayerTypes.CREATE_LAYER_REQUEST: {
      return state
        .setIn(['createLayer', 'isLoading'], true)
        .setIn(['createLayer', 'validationErrors'], fromJS({}))
    }

    case LayerTypes.CREATE_LAYER_SUCCESS: {
      return state.setIn(['createLayer', 'isLoading'], false)
    }

    case LayerTypes.CREATE_LAYER_FAILURE: {
      return state.setIn(['createLayer', 'isLoading'], false)
    }

    case LayerTypes.DELETE_LAYER_REQUEST: {
      return state
    }

    case LayerTypes.DELETE_LAYER_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case LayerTypes.DELETE_LAYER_FAILURE: {
      return state
    }

    case LayerTypes.FETCH_LAYERS_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case LayerTypes.FETCH_LAYERS_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case LayerTypes.FETCH_LAYERS_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case LayerTypes.FETCH_LAYER_REQUEST: {
      return state.setIn(['updateLayer', 'isLoading'], true)
    }

    case LayerTypes.FETCH_LAYER_SUCCESS: {
      return state
        .setIn(['updateLayer', 'isLoading'], false)
        .setIn(['updateLayer', 'data'], fromJS(action.payload))
    }

    case LayerTypes.FETCH_LAYER_FAILURE: {
      return state.setIn(['updateLayer', 'isLoading'], false)
    }

    case LayerTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case LayerTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
